define('controllers/hits',['require','johngrid','hotkeys','daterangepicker','services/googleanalytics','utils'],function(require) {
    var CreateJohnGrid = require('johngrid');
    require('hotkeys');
    require('daterangepicker');
    var googleAnalytics = require('services/googleanalytics');
    var utils = require('utils');
    return function () {
        //TODO: alt solution for far-right issue: just put shortids (of customers created before 9/14/2015) into or clause with contain filters, see if google cares if there are several hundred... //ORIGINAL ISSUE TODO: note we used to do server.transfer, so shorturls had been getting logged. SO use a regex to get old shortids--these didn't allow for '/' character so simply get pages that had one segment after the domain...https://regex101.com/r/hW4rU4/2  (^\/[a-z]+(?:\/\?|\?|$|\/$))
                    //so basically for each customer in the grid, make add to a list of customerFilters its shortid and also do the setEnrollemntInfo one below...
        //TODO: cache full results for a LOOONG time and re-use--give option to get fresh results, show time it was cached. Go ahead and show the grid without waiting for google data...
        var shortUrlFilter = 'ga:pagePath!@/login.aspx;ga:pagePath=@cid=';
        var deletethis = 'ga:pagePath=~^\/abbott,ga:pagePath=~^\/Ace,ga:pagePath=~^\/Advocate,ga:pagePath=~^\/Aurora,ga:pagePath=~^\/BNSF,ga:pagePath=~^\/CDW,ga:pagePath=~^\/Cerner,ga:pagePath=~^\/chevron,ga:pagePath=~^\/CHR,ga:pagePath=~^\/DeVry,ga:pagePath=~^\/DirecTV,ga:pagePath=~^\/Fastenal,ga:pagePath=~^\/HEButt,ga:pagePath=~^\/Humana,ga:pagePath=~^\/Jacobs,ga:pagePath=~^\/Kelly,ga:pagePath=~^\/LexisNexis,ga:pagePath=~^\/Marshfield,ga:pagePath=~^\/McLane,ga:pagePath=~^\/MGM,ga:pagePath=~^\/Northwestern,ga:pagePath=~^\/Parkview,ga:pagePath=~^\/Resurrection,ga:pagePath=~^\/RushU,ga:pagePath=~^\/StVincent,ga:pagePath=~^\/Starbucks,ga:pagePath=~^\/STIowa,ga:pagePath=~^\/PSPalmBeach,ga:pagePath=~^\/ThedaCare,ga:pagePath=~^\/Wheaton,ga:pagePath=~^\/Williams,ga:pagePath=~^\/Perkspot,ga:pagePath=~^\/ATP,ga:pagePath=~^\/711,ga:pagePath=~^\/PSAlbuquerque,ga:pagePath=~^\/AMC,ga:pagePath=~^\/AEO,ga:pagePath=~^\/Borgess,ga:pagePath=~^\/Bronson,ga:pagePath=~^\/CPK,ga:pagePath=~^\/Carnival,ga:pagePath=~^\/Chipotle,ga:pagePath=~^\/ClearChannel,ga:pagePath=~^\/Daimler,ga:pagePath=~^\/DePaul,ga:pagePath=~^\/dole,ga:pagePath=~^\/EDMC,ga:pagePath=~^\/PSFairfax,ga:pagePath=~^\/FinishLine,ga:pagePath=~^\/FirstGroup,ga:pagePath=~^\/GNC,ga:pagePath=~^\/Grainger,ga:pagePath=~^\/HBFuller,ga:pagePath=~^\/JohnsManvilleCorporation,ga:pagePath=~^\/Kerry,ga:pagePath=~^\/MemorialHermann,ga:pagePath=~^\/Mortons,ga:pagePath=~^\/MSTA,ga:pagePath=~^\/NAPW,ga:pagePath=~^\/NorthAmerican,ga:pagePath=~^\/NorthShore,ga:pagePath=~^\/SanDiegoCo,ga:pagePath=~^\/Sittercity,ga:pagePath=~^\/STColorado,ga:pagePath=~^\/Supervalu,ga:pagePath=~^\/THK,ga:pagePath=~^\/Zebra,ga:pagePath=~^\/FOA,ga:pagePath=~^\/MITC,ga:pagePath=~^\/Spotlite,ga:pagePath=~^\/Dell,ga:pagePath=~^\/PartnerPerks,ga:pagePath=~^\/USBC,ga:pagePath=~^\/IRG,ga:pagePath=~^\/ToysRUs,ga:pagePath=~^\/Epic,ga:pagePath=~^\/LockwoodVentures,ga:pagePath=~^\/AbbVie,ga:pagePath=~^\/STIllinois,ga:pagePath=~^\/UnityPoint,ga:pagePath=~^\/Jopari,ga:pagePath=~^\/FamilyD,ga:pagePath=~^\/HRPro,ga:pagePath=~^\/ASA,ga:pagePath=~^\/YMCAGTC,ga:pagePath=~^\/PKA,ga:pagePath=~^\/rho,ga:pagePath=~^\/Walgreens,ga:pagePath=~^\/maverick,ga:pagePath=~^\/Venrock,ga:pagePath=~^\/ReachLocal,ga:pagePath=~^\/SeeChangeHealth,ga:pagePath=~^\/BCBSMN,ga:pagePath=~^\/LXP,ga:pagePath=~^\/Premera,ga:pagePath=~^\/MAHU,ga:pagePath=~^\/Oakley,ga:pagePath=~^\/CostCo,ga:pagePath=~^\/HomeDepot,ga:pagePath=~^\/insperity,ga:pagePath=~^\/Kohler,ga:pagePath=~^\/RockwellCollins,ga:pagePath=~^\/Dominium,ga:pagePath=~^\/Intel,ga:pagePath=~^\/BlueCrossMN,ga:pagePath=~^\/LSSMN,ga:pagePath=~^\/Aon,ga:pagePath=~^\/NC,ga:pagePath=~^\/windriver';

        $(function () {
            window.hitit = function() {
                googleAnalytics.getCustomerHits('2015-09-01', '2015-09-15', {}).then(function(data) {
                    console.log('huzzah');
                    console.log(data);
                });
            };

			var table = $("#tblCustomerHits"),
				url = "hitsAJAX.aspx",
				columns = [{ DataField: "Index", HeaderText: "" },
							{ DataField: "Select", HeaderText: "" },
							{ DataField: "Name_Full", HeaderText: "Customer" },
							{ DataField: "UniqueHits", HeaderText: "Unique&nbsp;Hits&nbsp;(<span id='totalUniqueHits'></span>)&nbsp;<a href='#uniqueHitsInfo' class='infoLink'><img src='https://adestinn2blob.blob.core.windows.net/images/ico-question.png' alt='what's this' /></a>" },
							{ DataField: "SignedUp", HeaderText: "Members&nbsp;(<span id='totalSignedUp'></span>)" },
							{ DataField: "ConversionRate", HeaderText: "CR&nbsp;(<span id='AverageConversion'></span>)" },
							{ DataField: "LinkedAcct", HeaderText: "RPM&nbsp;(<span id='totalLinked'></span>)" },
							{ DataField: "RPMConversionRate", HeaderText: "UR&nbsp;(<span id='AverageRPMConversion'></span>)" }
				],
				grid = CreateJohnGrid(),
				txtFilterIPs = $("#txtFilterIPs"),
				tblHits = CreateJohnGrid(),
				hitColumns = [{ DataField: "Page", SortField: "QueryString" },
								{ DataField: "Count" }],
				header = $("#header"),
				timeFilters = $("[name='timeFilter']");

			grid.sorting.allowSorting = true;
			grid.dsPostValues.sortClause = "UniqueHits DESC";

			grid.onCreatingRows = function () {
				spn_totalHits.text(grid.currentDataSource.totalHitsForAll);
				spn_totalUniqueHits.text(grid.currentDataSource.totalUniqueHits);
				spn_totalSignedUp.text(grid.currentDataSource.totalSignedUp);
				spn_totalActivated.text(grid.currentDataSource.totalActivated);
				spn_totalLinked.text(grid.currentDataSource.totalLinked);
				spn_AverageConversion.text(grid.currentDataSource.AverageConversion);
				spn_AverageRPMConversion.text(grid.currentDataSource.AverageRPMConversion);
				grid.currentDataSource = grid.currentDataSource.hitDetails;
			};
			grid.onDataBinding = function () {
				setFilters(grid);
				//customer filtering
				grid.dsPostValues.customers = $("#txtCustomerFilter").val();

				//lead filtering
				var leads = [];
				$("[name='leadFilter']:checked").each(function() { leads.push($(this).val()); });
				grid.dsPostValues.leadFilter = leads.join(",");
			};
			grid.onDataBound = function () {
				$("#tblCustomerHits span.icon-remove").off("click").on("click", function () {
					var $this = $(this),
						item = grid.utilities.getItemForRowClick($this),
						txtCustomerFilter = $("#txtCustomerFilter"),
						currentValue = txtCustomerFilter.val().trim(),
						newValue = currentValue == "" ? item.plainName : currentValue + "|" + item.plainName;

					$this.hide().parent().append('<img src="https://adestinn2blob.blob.core.windows.net/images/loading.gif" style="float:right;" alt="loading..." />');

					txtCustomerFilter.val(newValue);
					grid.databind();
				});
			};
			$("#txtCustomerFilter, [name='leadFilter']").on("change", function () {
				grid.databind();
			});

			tblHits.sorting.allowSorting = true;
			tblHits.dsPostValues.sortClause = "Count DESC";
			tblHits.init($("#tblHits"), hitColumns, "hitsDrillAJAX.aspx");
			tblHits.onCreatingRows = function () {
				$("#totalForThisPage").text(tblHits.currentDataSource.totalHitsForThisPage);
				tblHits.currentDataSource = tblHits.currentDataSource.hits;
			}
			tblHits.onDataBinding = function () {
				$("#totalForThisPage").html(grid.htmlHelpers.loadingImg(true));
				setFilters(tblHits);
			};

			grid.selectHelpers.init($("#selectTemplate"));
			grid.selectHelpers.allowSelect = false; //added in custom column...

			grid.selectHelpers.useDataSourceItem = true;
			grid.selectHelpers.onSelect = function (item) {
				setGrid(tblHits);
				tblHits.dsPostValues.ShortID = item.PrimaryKey;
				$("#customerFilter").hide();
				tblHits.databind();
			};
			var cancelClk = grid.utilities.cancelClick;
			grid.utilities.cancelClick = function () {
				setGrid(grid);
				grid.databind();
				$("#customerFilter").show();
				cancelClk();
			};

			grid.init(table, columns, url);

			//after headers are created, set top total spans...
			var spn_totalHits = $("#totalHits"),
				spn_totalUniqueHits = $("#totalUniqueHits"),
				spn_totalSignedUp = $("#totalSignedUp"),
				spn_totalActivated = $("#totalActivated"),
				spn_totalLinked = $("#totalLinked"),
				spn_AverageConversion = $("#AverageConversion"),
				spn_AverageRPMConversion = $("#AverageRPMConversion");


			var tbl = grid;
			setGrid(grid);

			txtFilterIPs.focus();
			$(document).on('keyup', null, 'i', function () {
				txtFilterIPs.focus();
			});

			function setGrid(tblObj) {
				tbl = tblObj;

				header.off("keypress");
				Utilities.setDefaultButton(header, $(".btnRefresh", tbl.$table));

				txtFilterIPs.focus();

				$(".johnGridHeader", tbl.$table).prepend(header);
			}

			timeFilters.on("change", function () {
				$("#tfCustomRange").val("");
				var timeFilter = $(this).prop('id');
				BindTable(timeFilter);
			});

			function setFilters() {
				tbl.dsPostValues.filterIps = txtFilterIPs.val();
			}

			function BindTable(timeFilter) {
				grid.dsPostValues.timeFilter = timeFilter;
				tblHits.dsPostValues.timeFilter = timeFilter;
				tbl.databind();

				console.log(timeFilter);
			}

			//ability to filter by custom date range
			Utilities.generalDateRangePicker('#tfCustomRange', function (start, end) {
			    timeFilters.prop('checked', false);
			    var timeFilter = Utilities.getTimeFilter(start, end);
			    BindTable(timeFilter);
			},
            null,
            {
			    Start: Date.parse("7/29/2010"),
			    End: Date.today()
			});
		});
	};
});
